import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import moment from "moment";

import { P, H1 } from "../../../atoms/Texts";
import { PrimaryButton } from "../../../atoms/Buttons";

import ActionPageHero from "../../../molecules/ActionPageHero";
import { demoContext } from "../../../../shared/store/contexts";
import CaretLeftIcon from "../../../../assets/images/caret-left.svg";

const ProgramDetailsPage = () => {
  const { serviceId, id } = useParams();
  const { services } = useContext(demoContext);
  const loader = useRef(null);

  const [service, setService] = useState({});
  const [loading, setLoading] = useState(false);
  const [schedules, setSchedules] = useState({});

  useEffect(() => {
    setLoading(true);
    const serviceById = services?.find((i) => i.id === serviceId);

    setService(serviceById);
    setLoading(false);
    if (serviceById?.location) {
      setSchedules(JSON.parse(serviceById?.location?.schedule));
    }

    return () => {
      setService([]);
    };
  }, [serviceId, services]);

  const navigate = useNavigate();

  const goBack = () => {
    navigate(`/dashboard/organization/${id}/programs`);
  };

  return (
    <main className="flex flex-col w-full relative">
      <LoadingBar height={2} color="#00AF72" ref={loader} />
      <section className="flex justify-between items-center bg-[#F8F6FE] px-12 pt-12">
        <H1 fontSize="26px">Service Details</H1>

        <PrimaryButton.Light
          onClick={() => goBack()}
          className="flex items-center gap-x-3"
          w="fit-content"
        >
          {" "}
          <img src={CaretLeftIcon} alt="back to services" /> Back to All Service
        </PrimaryButton.Light>
      </section>
      <div className="flex justify-between items-center">
        <ActionPageHero
          className="organization-container"
          title={service?.name}
          description={service?.alternateName}
        />
      </div>
      <section className="mt-5 pb-10 md:py-18 mx-10">
        {loading ? (
          <>
            <div className="mb-8">
              <div className="animate-pulse rounded-md bg-gray-600 opacity-75 h-10 w-full md:w-1/2 mb-4"></div>
              <div className="animate-pulse rounded-md bg-gray-600 opacity-75 w-full md:w-2/3 h-5 mb-2"></div>
              <div className="animate-pulse rounded-md bg-gray-600 opacity-75 w-full md:w-2/3 h-5 mb-2"></div>
              <div className="animate-pulse rounded-md bg-gray-600 opacity-75 w-full md:w-2/3 h-5 mb-2"></div>
              <div className="animate-pulse rounded-md bg-gray-600 opacity-75 w-full md:w-2/3 h-5"></div>
            </div>
          </>
        ) : (
          <>
            {service?.id && (
              <>
                <div className="md:flex justify-between mt-2">
                  <div className="lg:w-2/3 mb-4">
                    <P color="" fontSize="14px" fontFamily="semi">
                      Description
                    </P>
                    <P>{service?.description}</P>
                  </div>
                  <div
                    className="lg:w-1/3 lg:pl-8 md:border-l mt-4 md:mt-0"
                    style={{
                      borderLeftColor: "#E6E5F1",
                      height: "fit-content",
                    }}
                  >
                    <P>{service?.schedule}</P>
                  </div>
                </div>

                {/* <H3 fontSize="18px" className="mt-8 mb-4">
                  Contact Details
                </H3> */}
                {service.email && service.email !== "None" && (
                  <div className="md:flex mt-6 mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Email
                    </P>
                    <div className="md:w-4/5">
                      <a href={`mailto:${service.email}`} className="">
                        <P className="mb-4 md:mb-0 hover:text-indigo-700">
                          {service.email}
                        </P>
                      </a>
                    </div>
                  </div>
                )}
                {service.url && service.url !== "None" && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Visit website
                    </P>
                    <div className="md:w-4/5">
                      <a
                        href={service.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        // className=" "
                      >
                        <P className="mb-2 hover:text-indigo-700" color="#2878F0">
                          {service.url}
                        </P>
                      </a>
                    </div>
                  </div>
                )}
                {service.interpretationServices?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Interpretation Services
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.interpretationServices}</P>
                    </div>
                  </div>
                )}
                {service.applicationProcess?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Application Process
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.applicationProcess}</P>
                    </div>
                  </div>
                )}
                {service.waitTime?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Wait Time
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.waitTime}</P>
                    </div>
                  </div>
                )}
                {service.cost?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Cost
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.cost}</P>
                    </div>
                  </div>
                )}
                {service?.overallCapacity && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Overall Capacity
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.overallCapacity}</P>
                    </div>
                  </div>
                )}
                {service?.currentlyServing && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Currently Serving
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.currentlyServing}</P>
                    </div>
                  </div>
                )}
                {service.accreditations?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Accreditations
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.accreditations}</P>
                    </div>
                  </div>
                )}
                {service.licenses?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Licenses
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.licenses}</P>
                    </div>
                  </div>
                )}
                {service.requiredDocuments?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Required Documents
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.requiredDocuments}</P>
                    </div>
                  </div>
                )}
                {service.paymentsAccepted?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Payments Accepted
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.paymentsAccepted}</P>
                    </div>
                  </div>
                )}
                {service.fundings?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Fundings
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.fundings}</P>
                    </div>
                  </div>
                )}
                {service.serviceAreas?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Service Areas
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.serviceAreas}</P>
                    </div>
                  </div>
                )}
                {service.eligibilities?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Eligibilities
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">{service.eligibilities}</P>
                    </div>
                  </div>
                )}
                {service.requiredDocuments?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Required Documents
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">{service.requiredDocuments}</P>
                    </div>
                  </div>
                )}
                <div className="md:flex mb-4">
                  <P
                    fontSize="14px"
                    className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                    fontFamily="semi"
                  >
                    Autoscreen
                  </P>
                  <div className="md:w-4/5">
                    <P className="mb-2 capitalize">
                      {!service.autoScreen ? "No" : "Yes"}
                    </P>
                  </div>
                </div>
                {service.opCategory?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Category
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">{service.opCategory}</P>
                    </div>
                  </div>
                )}
                {service.subOpCategory?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Sub-Category
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">{service.subOpCategory}</P>
                    </div>
                  </div>
                )}
                {service.languages?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Languages
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">{service.languages}</P>
                    </div>
                  </div>
                )}
                <div className="md:flex mb-4">
                  <P
                    fontSize="14px"
                    className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                    fontFamily="semi"
                  >
                    Draft
                  </P>
                  <div className="md:w-4/5">
                    <P className="mb-2 capitalize">
                      {!service.draft ? "No" : "Yes"}
                    </P>
                  </div>
                </div>
                <div className="md:flex mb-4">
                  <P
                    fontSize="14px"
                    className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                    fontFamily="semi"
                  >
                    Published
                  </P>
                  <div className="md:w-4/5">
                    <P className="mb-2 capitalize">
                      {!service.isPublished ? "No" : "Yes"}
                    </P>
                  </div>
                </div>
                {service.contacts?.length > 0 && (
                  <div className="md:flex mb-6">
                    <P
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontSize="14px"
                      fontFamily="semi"
                    >
                      Contacts
                    </P>
                    <div className="md:w-4/5">
                      {service.contacts.map((contact, index) => (
                        <div key={index}>
                          <P className="mb-2 flex items-center">
                            {contact.firstName} {contact.lastName}{" "}
                            {contact.email && (
                              <>
                                -{" "}
                                <a
                                  href={`mailto:${contact.email}`}
                                  className="block ml-2"
                                  style={{ width: "fit-content" }}
                                >
                                  <P
                                    fontSize="14px"
                                    className="flex items-center hover:text-indigo-700"
                                    style={{ width: "fit-content" }}
                                  >
                                    {contact.email}
                                    {/* <Icon.Mail
                                  // color="#442ecf"
                                  size={12}
                                  className="ml-2"
                                /> */}
                                  </P>
                                </a>
                              </>
                            )}
                          </P>
                          {contact.title && <P className="mb-2">{contact.title}</P>}
                          {contact.department && (
                            <P className="mb-2">{contact.department}</P>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {service.location?.name && (
                  <div className="md:flex mb-4">
                    <P
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontSize="14px"
                      fontFamily="semi"
                    >
                      Location
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2">{service.location.name}</P>
                      {service.location?.address && (
                        <>
                          <P className="mb-2">{service.location.address}</P>
                          <P className="mb-2">
                            {`${
                              service.location?.city
                                ? service.location?.city + ","
                                : ""
                            } ${service.location?.stateOrProvince} ${
                              service.location?.zipCode
                            }`}
                          </P>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {service.location?.accessibiltyForDisabilities && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Accessibility for Disabilities
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">
                        {service.location?.accessibiltyForDisabilities}
                      </P>
                    </div>
                  </div>
                )}
                {service.location?.schedule?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Schedule
                    </P>
                    <div className="md:w-4/5">
                      <table className="w-full md:w-1/2 bg-transparent border-collapse">
                        <thead>
                          <tr>
                            {["Day", "Opens", "Closes"].map((i) => (
                              <th
                                key={i}
                                scope="col"
                                className={
                                  "px-2 align-middle border border-solid border-l-0 border-r-0 border-gray-500 whitespace-nowrap text-left py-2"
                                }
                              >
                                {i}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-t-0 px-6 align-middle border-b border-solid border-gray-300 border-l-0 border-r-0 whitespace-nowrap py-6 ">
                            <td className="py-2">
                              <P>Monday</P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.mon?.start
                                  ? moment(schedules?.mon?.start, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.mon?.end
                                  ? moment(schedules?.mon?.end, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                          </tr>
                          <tr className="border-t-0 px-6 align-middle border-b border-solid border-gray-300 border-l-0 border-r-0 whitespace-nowrap py-6 ">
                            <td className="py-2">
                              <P>Tuesday</P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.tue?.start
                                  ? moment(schedules?.tue?.start, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.tue?.end
                                  ? moment(schedules?.tue?.end, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                          </tr>
                          <tr className="border-t-0 px-6 align-middle border-b border-solid border-gray-300 border-l-0 border-r-0 whitespace-nowrap py-6 ">
                            <td className="py-2">
                              <P>Wednesday</P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.wed?.start
                                  ? moment(schedules?.wed?.start, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.wed?.end
                                  ? moment(schedules?.wed?.end, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                          </tr>
                          <tr className="border-t-0 px-6 align-middle border-b border-solid border-gray-300 border-l-0 border-r-0 whitespace-nowrap py-6 ">
                            <td className="py-2">
                              <P>Thursday</P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.thur?.start
                                  ? moment(schedules?.thur?.start, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.thur?.end
                                  ? moment(schedules?.thur?.end, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                          </tr>
                          <tr className="border-t-0 px-6 align-middle border-b border-solid border-gray-300 border-l-0 border-r-0 whitespace-nowrap py-6 ">
                            <td className="py-2">
                              <P>Friday</P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.fri?.start
                                  ? moment(schedules?.fri?.start, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.fri?.end
                                  ? moment(schedules?.fri?.end, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                          </tr>
                          <tr className="border-t-0 px-6 align-middle border-b border-solid border-gray-300 border-l-0 border-r-0 whitespace-nowrap py-6 ">
                            <td className="py-2">
                              <P>Saturday</P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.sat?.start
                                  ? moment(schedules?.sat?.start, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.sat?.end
                                  ? moment(schedules?.sat?.end, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                          </tr>
                          <tr className="border-t-0 px-6 align-middle border-b border-solid border-gray-300 border-l-0 border-r-0 whitespace-nowrap py-6 ">
                            <td className="py-2">
                              <P>Sunday</P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.sun?.start
                                  ? moment(schedules?.sun?.start, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                            <td className="py-2">
                              <P>
                                {schedules?.sun?.end
                                  ? moment(schedules?.sun?.end, "HH:mm").format(
                                      "hh:mmA",
                                    )
                                  : "Not available"}
                              </P>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <P className="my-2 capitalize" fontFamily="medium">
                        Timezone: {schedules?.timezone}
                      </P>
                    </div>
                  </div>
                )}
                {service.languages?.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Languages
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">{service.languages}</P>
                    </div>
                  </div>
                )}
                {service.location?.transportation.length > 0 && (
                  <div className="md:flex mb-4">
                    <P
                      fontSize="14px"
                      className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                      fontFamily="semi"
                    >
                      Transportation
                    </P>
                    <div className="md:w-4/5">
                      <P className="mb-2 capitalize">
                        {service.location?.transportation}
                      </P>
                    </div>
                  </div>
                )}
                {service.phones?.length > 0 &&
                  service.phones?.[0]?.number !== "None" && (
                    <div className="md:flex mb-4">
                      <P
                        className="md:w-1/5 mb-2 md:mb-0 md:mr-4"
                        fontSize="14px"
                        fontFamily="semi"
                      >
                        Phones
                      </P>
                      <div className="md:w-4/5">
                        {service.phones.map((phone, index) => (
                          <a
                            key={index}
                            href={`tel:+${phone.extension}${phone.number}`}
                          >
                            <P className="mb-2">
                              ({phone.extension}){phone.number}
                            </P>
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
              </>
            )}
          </>
        )}
      </section>
    </main>
  );
};

export default ProgramDetailsPage;
